import {
  DirectionEnum,
  type IDropdownItemShifts,
  type TTimeHHmm,
} from "@ryde/shared";

/**
 * Which direction picking a shift lands on. A shift covering both directions, or carrying none, is
 * not a both-directions state the panel can hold - a run applies to one direction - so it lands on A.
 */
export const resolveDirectionFromShift = (
  shift?: IDropdownItemShifts,
): DirectionEnum =>
  shift?.direction === DirectionEnum.DropOff
    ? DirectionEnum.DropOff
    : DirectionEnum.PickUp;

/**
 * The shift time that belongs to the direction being applied: A leaves at the shift's start, B at its
 * end. The create panel keeps both in two fields and shows one; this panel has a single time field,
 * so the value has to be re-derived whenever the direction changes.
 */
export const resolveShiftTimeForDirection = ({
  shift,
  direction,
}: {
  shift?: IDropdownItemShifts;
  direction?: DirectionEnum;
}): TTimeHHmm | undefined =>
  direction === DirectionEnum.DropOff
    ? shift?.shiftEndTime
    : shift?.shiftStartTime;
